import { useLanguage } from "@onesolution/hooks";

import { getUserByIdFromServer } from "@onesolution/serverFn/user";
import { FormDrawer, OpenMode } from "../FormDrawer/FormDrawer";
import UserForm from "./UserForm";

export default function UserDrawer({
	mode,
	selectedUserId,
	onClose,
}: { mode: OpenMode; selectedUserId?: string; onClose: () => void }) {
	const { t } = useLanguage();
	const userQuery = getUserByIdFromServer.useQuery(
		{ id: selectedUserId || "" },
		{ enabled: Boolean(selectedUserId) },
	);

	return (
		<FormDrawer
			openMode={mode}
			isLoading={userQuery.isFetching}
			selectedItem={
				selectedUserId && userQuery.data ? userQuery.data : undefined
			}
			headers={{
				[OpenMode.details]: (selectedItem) => {
					return `${selectedItem?.firstname?.toUpperCase() || ""} ${selectedItem?.lastname?.toUpperCase() || ""}`;
				},
				[OpenMode.creation]: () => `${t("basic.create")} ${t("name.user")}`,
				[OpenMode.edition]: () => `${t("basic.edit")} ${t("name.user")}`,
			}}
			onClose={onClose}
			form={({ loadedData, ...props }) => (
				<UserForm {...props} loadedData={loadedData} />
			)}
		/>
	);
}
